module.exports = __webpack_public_path__ + "static/media/SacredHeartSchoolHaverhill.072deba8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/schools/logos/SacredHeartSchoolHaverhill.png
// module id = 661
// module chunks = 0